
// value should be same as table name => easier when lookup for entity data
export enum VariationEntityType {
    Job = 'jobs',
    WO = 'workOrders'
}